import React from 'react';

import { CircularProgress, Grid } from '@mui/material';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  container: {
    flexGrow: 1,
  },
}));

export function CenteredLoader({
  children,
  className,
}: React.HTMLAttributes<HTMLElement>): JSX.Element {
  const { classes } = useStyles();

  return (
    <Grid
      container
      className={clsx(className, classes.container)}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
      {children}
    </Grid>
  );
}
